import {
  useCallback,
  useState,
} from 'react';
import { useDispatch } from 'react-redux';
import { createUuid } from '../_shared/utils/createUuid';
import {
  closeModal, openNewModalWithId, replaceCurrentNewModalWithAndUseCustomId,
} from '../store/modal/modal.actionCreators';
import {
  type ModalName,
  type ModalTypeProps,
} from './modalRegistry.type';

type NewModalRenderer<T extends ModalName> = undefined extends ModalTypeProps<T>
  ? (props?: ModalTypeProps<T>) => void
  : (props: ModalTypeProps<T>) => void;

export const useModal = <K extends ModalName>(dialogType: K, customId?: string) => {
  const dispatch = useDispatch();
  const [id] = useState(customId ?? createUuid());

  const openModalLocal: NewModalRenderer<K> = useCallback(
    (modalProps: ModalTypeProps<K>) => dispatch(openNewModalWithId(id, dialogType, modalProps)),
    [dispatch, id, dialogType]
  ) as any;
  const replaceCurrentModal: NewModalRenderer<K> = useCallback(
    (props: ModalTypeProps<K>) => dispatch(replaceCurrentNewModalWithAndUseCustomId(id, dialogType, props)),
    [dispatch, id, dialogType]
  ) as any;

  const closeModalLocal = useCallback(() => dispatch(closeModal(id)), [dispatch, id]);

  return {
    closeModal: closeModalLocal,
    openModal: openModalLocal,
    replaceCurrentModal,
  };
};
